import { Text } from "@chakra-ui/react";
import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = { schoolForm: { id: string; isOverride?: boolean | null } | null };
export function buildEligibilityOverrideColumnDef<
  T extends Row
>(): ColumnDefWithTooltip<T> {
  return {
    accessorFn: (row) => row.schoolForm?.isOverride,
    id: ColumnId.EligibilityOverride,
    header: "Eligibility override",
    cell: (props) => {
      const schoolForm = props.row.original.schoolForm;
      if (!schoolForm) {
        return <Text variant="placeholder">-</Text>;
      }
      return schoolForm.isOverride ? "Yes" : "No";
    },
  };
}
